import { ConfirmDetails } from './Components/ConfirmDetails';
import { SelectSource } from './Components/SelectSource';
import { SuccessfulSubmission } from './Components/SuccessfulSubmission';
import {
  BULK_SUBMIT_SELECT_SOURCE,
  BULK_SUBMIT_SUBMITTED,
  BULK_SUBMIT_VALIDATE_DATA,
} from './constants';

export const getStepComponent = (wizardStep, props) => {
  const TYPES = {
    [BULK_SUBMIT_SELECT_SOURCE]: <SelectSource {...props} />,
    [BULK_SUBMIT_VALIDATE_DATA]: <ConfirmDetails {...props} />,
    [BULK_SUBMIT_SUBMITTED]: <SuccessfulSubmission {...props} />,
  };

  return TYPES[wizardStep];
};
